class Sort extends HTMLElement {
  constructor() {
    super()
    const sort = this
    this.openButton = document.querySelector('[data-sort-open]')
    this.closeButtons = this.querySelectorAll('[data-sort-close]')
    this.toggleDesktopButton = this.querySelector('.collection-sort__active')
    this.list = this.querySelector('.collection-sort__list')

    this.openButton.addEventListener('click', this.openSortDrawer.bind(sort))
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.closeSortDrawer.bind(sort))
    })
    this.toggleDesktopButton.addEventListener('click', this.openDesktopList.bind(this))
    
    this.initInputs()
  }

  initInputs() {
    this.inputs = this.querySelectorAll('[data-sort-input]')
    this.inputs.forEach(input => {
      input.addEventListener('change', this.initReload.bind(this))
    })
  }


  initReload(event) {
    this.querySelectorAll('[data-sort-input]').forEach( input => {
      input == event.target ? input.checked  = true : input.checked = false 
    })
    document.querySelector('component-filter').createParams()
    this.closeSortDrawer()
  }

  openSortDrawer() {
    document.body.style.overflow = 'hidden'
    this.classList.add('collection-sort--display')
    setTimeout(() => {
      this.classList.add('collection-sort--opened')
    }, 100);
  }

  closeSortDrawer() {
    document.body.style.overflow = 'auto'
    this.classList.remove('collection-sort--opened')
    setTimeout(() => {
      this.classList.remove('collection-sort--display')
    }, 300);
  }

  generateURLParams() {
    let sortData = new FormData(this.querySelector('form'));
    let sortParams = new URLSearchParams(sortData).toString();
    return sortParams
  }

  updateSort(element) {
    this.closeDesktopList()
    this.toggleDesktopButton.innerHTML = element.innerHTML
  }

  openDesktopList() {
    if (this.list.classList.contains('collection-sort__list--display')) {
      this.closeDesktopList()
      return
    }
    this.list.classList.add('collection-sort__list--display')
    setTimeout(() => {
      this.list.classList.add('collection-sort__list--active')
    }, 100);
  }

  closeDesktopList() {
    this.list.classList.remove('collection-sort__list--active')
    setTimeout(() => {
      this.list.classList.remove('collection-sort__list--display')
    }, 300);
  }
}

customElements.define('component-sort', Sort);

class SortWithoutFilter extends Sort {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId
  }

  initReload(event) {
    this.querySelectorAll('[data-sort-input]').forEach( input => {
      input == event.target ? input.checked  = true : input.checked = false
    })
    this.createParams()
    this.closeSortDrawer()
  }

  createParams() {
    let params = this.generateURLParams();
    let url = `?section_id=${this.sectionId}&` + params;
    this.pullData(url, params)
  }

  pullData(url, params) {
    this.closest('[data-collection-grid]')?.classList.add('collection--loading')
    fetch(window.location.pathname + url)
      .then(response => {
        return response.text()
      })
      .then(html => {
        let collectionList = document.querySelector('.main-collection__list')
        let sort = document.querySelector('.collection-sort__list')
        let newCollectionHTML = new DOMParser().parseFromString(html, 'text/html');

        collectionList.innerHTML = newCollectionHTML.querySelector('.main-collection__list').innerHTML
        sort.innerHTML = newCollectionHTML.querySelector('.collection-sort__list').innerHTML
        this.initInputs()
        this.updateSort(newCollectionHTML.querySelector('.collection-sort__active'))

        /* Get UTM marks from URL */
        let utmMarksArray = [];
        if (window.location.search.includes('utm_')) {
          window.location.search.replace('?', '').split('&').forEach(elem => {
            if (elem.includes('utm_')) {
              utmMarksArray.push(elem)
            }
          })
        }

        if (utmMarksArray.length) {
          params += params == '' ? '?'.concat(utmMarksArray.join('&')) : utmMarksArray.join('&')
        }

        history.pushState({ params }, '', `${window.location.pathname}${params && '?'.concat(params)}`)
        this.initInputs()
      }).finally(() => {
        this.closest('[data-collection-grid]')?.classList.remove('collection--loading')
      });
  }
}

customElements.define('component-sort-without-filter', SortWithoutFilter);
class GridChanger extends HTMLElement {
  constructor() {
    super()
    this.buttons = this.querySelectorAll('[data-state]')
    this.initButton()

    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        if (button.dataset.state == 'list') {
          sessionStorage.setItem('gridState', 'list')
        } else {
          sessionStorage.removeItem('gridState')
        }
        this.initButton()
      })
    })
  }

  initButton() {
    let currentState = sessionStorage.getItem('gridState') || 'tiles';
    this.buttons.forEach(button => {
      button.classList.toggle('mobile-bar__grid-change__button--active', button.getAttribute('data-state') == currentState);
    });
    this.changeLayout(currentState)
  }

  changeLayout(state) {
    let collectionProductList = document.querySelector('.main-collection__list')
    collectionProductList.classList.toggle('main-collection__list--tiles', state == 'tiles')
  }
}

customElements.define('grid-changer', GridChanger);